module.exports = __webpack_public_path__ + "static/img/2.da9f95e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/2.png
// module id = 1IFy
// module chunks = 0